import React, { useCallback, useEffect, useState } from "react";
import "rc-dropdown/assets/index.css"; // Import the default styles
import styles from "./search.module.css"; // Import your CSS module
import DropDown from "common/RcDropDown";
import { postData } from "utils/queries";
import { useLocation, useNavigate } from "react-router-dom";
import { debounce } from "utils";

const Search = () => {
  const [searchResult, setSearchResult] = useState([]);

  const [searchTerm, setSearchTerm] = useState(null);

  const navigate = useNavigate();

  const location = useLocation();



  const menu = () => {
    return (
      <div className={styles.notificationDropdown}>
        {searchResult?.length > 0 && searchTerm ? (
          searchResult.map((obj) => (
            <div
              key={obj?.id}
              className={styles.objItem}
              onClick={() => navigate(obj?.link)}
            >
              {obj?.name}
            </div>
          ))
        ) : (
          <div>No Result</div>
        )}
      </div>
    );
  };

  const comp = (
    <div className={styles.search}>
      <img className={styles.searchIcon} src="/icons/searchWhite.svg" />
      <input
        placeholder="Search"
        onChange={(e) => {
          setSearchTerm(e?.target?.value?.trim());
        }}
      />
    </div>
  );

  let type, link;

  const path = location?.pathname;


  // useEffect(()=>{

    if (path.includes("event")) {
      type = "event";
      link = `event/event-details`;
    } else if (path.includes("ticket")) {
      type = "ticket";
      link = `ticket/edit-ticket`;
    } 
    // else if (path.includes("package")) {
    //   type = "package";
    // }
  // })


  
  console.log("apth is ------", path, type, link)

  const getResult = async ({type,searchTerm}) => {
    console.log("apth is", path, type, searchTerm,link)

    try {
      const result = await postData("search/", {
        type,
        search: searchTerm,
      });

      setSearchResult(
        result?.data?.data?.map((e) => ({ ...e, link: `${link}/${e?.id}` }))
      );
    } catch (error) {}
  };
  const getResultDebounce = debounce((searchTerm)=>getResult({type, searchTerm}),300)
  useEffect(() => {
    if (searchTerm?.length > 0&&type&&link) {
      getResultDebounce(searchTerm); // Pass the searchTerm to the debounced function
    }
  }, [searchTerm,type,link]); // Ensure to update when searchTerm changes

  return (
    <>
      {type&&<DropDown
        data={searchResult}
        childComp={comp}
        renderFunc={menu}
        event="click"
      />}
    </>
  );
};

export default Search;
